<div
  #imageHeaderContainer
  class="image-header-container d-flex flex-column justify-content-end align-items-sm-start"
  [style.background-image]="
    linearGradient + ', url(&quot;' + (imgL | gpuMediaQuery: imgS) + '&quot;)'
  "
>
  <div class="container gpy-12" #contentContainer>
    <ng-content></ng-content>
  </div>
</div>

<div #backContainer class="back container">
  <ng-content select="gpt-router-back"></ng-content>
</div>

<div
  #analysisHeaderContainer
  class="analysis-header-container"
  [class.invisible]="analysisHeaderTop < 0"
  [style.top.px]="analysisHeaderTop"
>
  <app-analysis-header class="d-print-none" (heightChanged)="updateHeight()">
    <gpt-router-back [url]="routerBackUrl" [forceUrl]="true"></gpt-router-back>

    <app-analysis-header-title>
      <h4 class="h4-bold mb-0">
        {{ title }}
      </h4>
    </app-analysis-header-title>
  </app-analysis-header>
</div>
